import Proxies from 'Components/proxies'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import CollapsibleCard from 'Components/collapsibleCard'
import DynamicTable from 'Components/dynamicTable'
import moment from 'moment'
import { Button, ButtonGroup } from 'reactstrap'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const OrderCommunication = props => {
  const [communications, setCommunications] = useState([])

  const fetchCommunication = () => {
    Proxies.GET('orders/getCommunicationForOrder', { ConfirmationID: props.ConfirmationID }).then(responseJSON => {
      if (responseJSON && responseJSON.error) {
        toast.error('Fetching communication failed', {
          autoClose: 3000
        })
      } else {
        setCommunications(responseJSON)
      }
    })
  }

  useEffect(() => {
    if (props.ConfirmationID) {
      fetchCommunication()
    }
  }, [props.ConfirmationID])

  return (
    <CollapsibleCard startOpen={false} header={<strong>Kommunikation</strong>}>
      {communications?.length > 0 ? (
        <DynamicTable
          responsive
          size='sm'
          showAll
          hideSearch
          data={communications}
          headers={{
            communicationChannel: 'Kanal',
            communicationRecipient: 'Modatger',
            communicationSubject: 'Emne',
            OrderID: 'Ordrenummer',
            timeInsert: 'Dato'
          }}
          options={{
            startSort: {
              dir: 'DESC',
              column: 'OrderID'
            },
            fieldFunctions: {
              timeInsert: e => {
                return e.timeInsert ? moment(e.timeInsert).format('YYYY-MM-DD HH:mm') : ''
              },
              fieldStringFunctions: {
                timeInsert: e => {
                  return moment(e.timeInsert).format('x')
                }
              }
            },
            addField: e => {
              return (
                <td>
                  <ButtonGroup>
                    <Button tag={Link} to={`/communication/${e.id}/elements`}>
                      <FontAwesomeIcon icon='eye' />
                    </Button>
                  </ButtonGroup>
                </td>
              )
            }
          }}
        />
      ) : (
        <p>Ingen kommunikation for denne ordre.</p>
      )}
    </CollapsibleCard>
  )
}

export default OrderCommunication
